import { Component, OnInit } from '@angular/core';
import { SigninService } from '../../authentification/signin/signin.service';
import { User } from 'src/app/authentification/signin/credentials';
import { MatDialog } from '@angular/material/dialog';
import { AccountFormComponent } from './account-form/account-form.component';

@Component({
  selector: 'app-account-management',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.css']
})
export class AccountManagementComponent implements OnInit {
  accounts: User[];
  loading = false;
  searchTerm = '';

  get filteredAccounts(): User[] {
    if (!this.accounts || !this.searchTerm || !this.searchTerm.trim()) {
      return this.accounts;
    }
    const term = this.searchTerm.toLowerCase().trim();
    return this.accounts.filter(a =>
      (a.username && a.username.toLowerCase().includes(term)) ||
      (a.displayName && a.displayName.toLowerCase().includes(term))
    );
  }
  constructor(
    private signinService: SigninService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.signinService.getAccounts().subscribe( listAcount =>{
      this.accounts = listAcount;
      this.loading = false;
    },
    () => {
      this.loading = false;
    });

    this.signinService.getAccountWasCreated().subscribe(account => {
      if (account && this.accounts) {
        this.accounts.push(account);
      }
    });

    this.signinService.getAccountWasDeleted().subscribe(account => {
      if (account && this.accounts) {
        this.accounts = this.accounts.filter(a => a.id !== account.id);
      }
    });

    this.signinService.getAccountWasChanged().subscribe(account => {
      if (account && this.accounts) {
        const index = this.accounts.findIndex(a => a.id === account.id);
        if (index !== -1) {
          this.accounts[index] = account;
        }
      }
    });
  }

  openAddDialog() {
    this.dialog.open(AccountFormComponent, {
      width: '750px',
      maxWidth: '95vw',
      height: '90vh',
      panelClass: 'account-form-dialog',
      data: { mode: 'ADD' }
    });
  }
}
